import { Fragment, useEffect, useState, useCallback, useRef } from "react";
import { useSelector, useDispatch, connect } from "react-redux";
import "./package_details_component.scss";
import LoaderPopUp from "../../../../../../components/loader/loader";
import HeaderComponent from "../../../../structure_components/desktop_screens/header_component/header_component";
import "react-toastify/dist/ReactToastify.css";
import uiActions from "../../../../../../redux/ui/action";
import { setStoreCurrentPackageDetails } from "../../../../../../redux/packages_store/PackageSlice";
import FrequentlyBought from "../modal/FrequentlyBought/FrequentlyBought";
import { StoreBanner } from "./package_overview/StoreComponents/StoreBanner/StoreBanner";
import { StoreTabs } from "./package_overview/StoreComponents/StoreTabs/StoreTabs";
import { StoreDescription } from "./package_overview/StoreComponents/StoreDescription/StoreDescription";
import { StoreOrientationVideo } from "./package_overview/StoreComponents/StoreOrientationVideo/StoreOrientationVideo";
import { StoreCourseBenifits } from "./package_overview/StoreComponents/StoreCourseBenifits/StoreCourseBenifits";
import { StoreComboCourses } from "./package_overview/StoreComponents/StoreComboCourses/StoreComboCourses";
import { StorePerformanceBanner } from "./package_overview/StoreComponents/StorePerformanceBanner/StorePerformanceBanner";
import { StoreFacultyDetails } from "./package_overview/StoreComponents/StoreFacultyDetails/StoreFacultyDetails";
import { StoreOtherDetails } from "./package_overview/StoreComponents/StoreOtherDetails/StoreOtherDetails";
import { StoreFaq } from "./package_overview/StoreComponents/StoreFaq/StoreFaq";
import { StoreSubjects } from "./package_overview/StoreComponents/StoreSubjects/StoreSubjects";
import { useLocation, useParams } from "react-router-dom";
import { shouldHideStoreCheckoutHeader } from "../../../../../../custom_utilities/dashboardBannerNavigation";
import { Render } from "../../../../../homepage/Render";
import { fetchPackageData } from "./package_overview/StoreComponents/StoreUtils/StoreApiUtils";
import StoreVariantSelection from "./package_overview/StoreComponents/StoreVariantSelection/StoreVariantSelection";
import StoreFrequentlyBought from "./package_overview/StoreComponents/StoreFrequentlyBought/StoreFrequentlyBought";
import StorePaymentPage from "./package_overview/StoreComponents/StorePaymentPage/StorePaymentPage";
import { StoreRecentBought } from "./package_overview/StoreComponents/StoreRecentBought/StoreRecentBought";
import { trackWebEngageProgramViewed } from "../../../../../../custom_utilities/webengage/webengageService";

const PackageDetailsComponent = ({ setStoreCurrentPackageDetails }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: selectedPackageId } = useParams();
  const loader = useSelector((state) => state.ui.loader);
  const variantChangeRef = useRef(false);
  const programViewedRef = useRef(null);
  const [packageData, setPackageData] = useState(null);
  const [initialPackageVariants, setInitialPackageVariants] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedRelatedPackages, setSelectedRelatedPackages] = useState([]);
  const [selectedFrequentPackages, setSelectedFrequentPackages] = useState([]);
  const [addonDiscount, setAddonDiscount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [couponCode, setCouponCode] = useState(
    typeof location.state === "string" ? location.state : ""
  );
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [showFrequentlyBoughtDetails, setShowFrequentlyBoughtDetails] =
    useState(false);
  const [frequentlyBoughtDetails, setFrequentlyBoughtDetails] = useState(null);
  const [active, setActive] = useState("desc");

  const startLoading = useCallback(
    () => dispatch(uiActions.startLoading()),
    [dispatch]
  );
  const finishLoading = useCallback(
    () => dispatch(uiActions.finishLoading()),
    [dispatch]
  );

  useEffect(() => {
    if (!selectedPackageId) return;

    finishLoading();
    variantChangeRef.current = false;
    programViewedRef.current = null;
    setPackageData(null);
    setInitialPackageVariants(null);
    setSelectedPackage(null);
    setSelectedRelatedPackages([]);
    setSelectedFrequentPackages([]);
    setCouponCode(typeof location.state === "string" ? location.state : "");
    setCouponDiscount(0);
    setAddonDiscount(0);
    setActive("desc");

    fetchPackageData({
      packageId: selectedPackageId,
      isInitialLoad: true,
      setPackageData,
      setStoreCurrentPackageDetails,
      setFinalAmount,
      setInitialPackageVariants,
      setSelectedPackage,
      startLoading,
      finishLoading,
    });
  }, [
    selectedPackageId,
    setStoreCurrentPackageDetails,
    startLoading,
    finishLoading,
    location.state,
  ]);

  useEffect(() => {
    const product = selectedPackage || packageData;
    const productId = product?.package_id || selectedPackageId;
    if (!product || !productId) return;
    if (programViewedRef.current === String(productId)) return;

    programViewedRef.current = String(productId);
    const installment = packageData?.PackageInstallmentDetails || {};
    const priceDetails = packageData?.price_details || {};
    const mrp =
      product?.amount ||
      priceDetails?.course_price ||
      installment?.amount;
    const payable =
      finalAmount ||
      product?.discounted_price ||
      product?.amount ||
      installment?.discounted_price;
    const discount =
      product?.discount ||
      priceDetails?.discount ||
      installment?.discount ||
      (mrp != null && payable != null ? Number(mrp) - Number(payable) : 0);

    trackWebEngageProgramViewed(
      {
        ...installment,
        ...product,
        package_id: productId,
        package_name:
          product?.package_name ||
          product?.title ||
          product?.name ||
          installment?.package_name,
        description: product?.description || installment?.description,
        discount,
        amount: mrp,
        discounted_price: payable,
        price_details: priceDetails,
      },
      { offers: discount }
    );
  }, [packageData, selectedPackage, selectedPackageId, finalAmount]);

  const handleVariantSelection = useCallback((nextPackage) => {
    variantChangeRef.current = true;
    setSelectedPackage(nextPackage);
  }, []);

  useEffect(() => {
    if (!variantChangeRef.current) return;

    const nextPackageId = selectedPackage?.package_id;
    if (!nextPackageId) return;
    if (Number(nextPackageId) === Number(selectedPackageId)) {
      variantChangeRef.current = false;
      return;
    }

    variantChangeRef.current = false;
    setCouponCode("");
    setCouponDiscount(0);
    setAddonDiscount(0);

    fetchPackageData({
      packageId: nextPackageId,
      isInitialLoad: false,
      setPackageData,
      setStoreCurrentPackageDetails,
      setFinalAmount,
      setInitialPackageVariants,
      setSelectedPackage,
      startLoading,
      finishLoading,
    });
  }, [
    selectedPackage?.package_id,
    selectedPackageId,
    setStoreCurrentPackageDetails,
    startLoading,
    finishLoading,
  ]);

  // Price calculations
  useEffect(() => {
    if (
      packageData &&
      packageData.price_details &&
      packageData.price_details.course_price != null
    ) {
      const basePrice =
        parseFloat(packageData.price_details.course_price || 0) -
        parseFloat(packageData.price_details.discount || 0);

      // Ensure couponDiscount doesn't exceed basePrice
      const validCouponDiscount = Math.min(
        parseFloat(couponDiscount || 0),
        basePrice
      );

      const relatedPackagesPrice = selectedRelatedPackages.reduce(
        (sum, pkg) => sum + parseFloat(pkg.amount || 0),
        0
      );

      const totalAddonDiscount = selectedRelatedPackages.reduce(
        (sum, pkg) => sum + parseFloat(pkg.discount || 0),
        0
      );

      const calculatedFinalAmount =
        basePrice -
        validCouponDiscount +
        relatedPackagesPrice -
        totalAddonDiscount;
      setAddonDiscount(totalAddonDiscount.toFixed(2));
      setFinalAmount(Math.max(0, calculatedFinalAmount).toFixed(2));
    } else {
      console.warn("Skipping finalAmount calculation: incomplete packageData", {
        packageData,
      });
    }
  }, [packageData, selectedRelatedPackages, couponDiscount]);

  const openFrequentBoughtDetails = (data) => {
    setFrequentlyBoughtDetails(data);
    setShowFrequentlyBoughtDetails(true);
  };
  const closeFrequentlyBoughtDetails = () =>
    setShowFrequentlyBoughtDetails(false);

  const hideAppHeader = shouldHideStoreCheckoutHeader(location);

  return (
    <Fragment>
      {!hideAppHeader ? <HeaderComponent /> : null}
      <div
        className={`store_page${
          hideAppHeader ? " store_page--from-dashboard" : ""
        }`}
      >
        <div className="store_page__content">
          <StoreBanner packageData={packageData?.PackageInstallmentDetails} />
          <StoreTabs
            packageData={packageData}
            active={active}
            setActive={setActive}
          />
          <StoreRecentBought
            packageData={
              packageData?.PackageInstallmentDetails?.buyers_animation
            }
          />
          <Render if={active === "desc"}>
            <>
              <StoreDescription
                packageData={packageData?.PackageInstallmentDetails}
              />
              <StoreVariantSelection
                initialPackageVariants={initialPackageVariants}
                selectedPackage={selectedPackage}
                setSelectedPackage={handleVariantSelection}
                selectedPackageId={selectedPackageId}
              />
              <StoreOrientationVideo
                packageData={packageData?.orientation_video}
              />
              <StoreCourseBenifits
                packageData={
                  packageData?.PackageInstallmentDetails?.course_benefits
                }
              />
              <StoreFrequentlyBought
                packageData={packageData}
                selectedRelatedPackages={selectedRelatedPackages}
                setSelectedRelatedPackages={setSelectedRelatedPackages}
                selectedFrequentPackages={selectedFrequentPackages}
                setSelectedFrequentPackages={setSelectedFrequentPackages}
                openFrequentBoughtDetails={openFrequentBoughtDetails}
              />
              <StoreComboCourses
                packageData={packageData?.package_combos?.combo_options}
              />
              <StorePerformanceBanner />
              <StoreFacultyDetails packageData={packageData?.faculty_list} />
              <StoreOtherDetails packageData={packageData?.other_details} />
              <StoreFaq packageData={packageData?.faq} />
            </>
          </Render>
          <Render if={active === "subjects"}>
            <StoreSubjects packageData={packageData?.subject} />
          </Render>
        </div>
        <StorePaymentPage
          selectedFrequentPackages={selectedFrequentPackages}
          packageData={packageData}
          selectedPackage={selectedPackage}
          selectedPackageId={selectedPackageId}
          addonDiscount={addonDiscount}
          finalAmount={finalAmount}
          setFinalAmount={setFinalAmount}
          couponCode={couponCode}
          couponDiscount={couponDiscount}
          setCouponDiscount={setCouponDiscount}
          setCouponCode={setCouponCode}
          setAddonDiscount={setAddonDiscount}
          startLoading={startLoading}
          finishLoading={finishLoading}
          selectedRelatedPackages={selectedRelatedPackages}
        />
      </div>
      <Render if={showFrequentlyBoughtDetails}>
        <FrequentlyBought
          handleClose={closeFrequentlyBoughtDetails}
          frequentlyBoughtDetails={frequentlyBoughtDetails}
        />
      </Render>

      <Render if={loader}>
        <LoaderPopUp />
      </Render>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  orderId: state.paymentReducer.orderId,
});

const mapDispatchToProps = (dispatch) => ({
  setStoreCurrentPackageDetails: (payload) =>
    dispatch(setStoreCurrentPackageDetails(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PackageDetailsComponent);
